export default "__VITE_ASSET__DXQ_iqTp__"